export default __webpack_public_path__ + "static/jeans-3446d3d22bc0ec1158383e524719b598.jpg";